// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2dEW2","containerItemsCenter":"Skeleton_containerItemsCenter__2uJx7"};